import {
    IVirtualKeyboardDetector,
    VirtualKeyboardData,
    VKEYBOARD_ANIMATION_DURATION,
} from '@/utils/virtual_keyboard_detector';
import { IJumpToBottom } from './jump_to_bottom';

export interface IContentWrapper {
    setJumpToBottom(jumpToBottom: IJumpToBottom): void;
    open(): void;
    close(): void;
    setElement(element: HTMLElement): void;
}

const HEADER_ID = 'header_bar';

export class ContentWrapper implements IContentWrapper {
    element: HTMLElement;
    jumpToBottom: IJumpToBottom;
    isOpen = false;
    isMobile: boolean;
    height: string;

    virtualKeyboardDetector: IVirtualKeyboardDetector;
    virtualKeyboardListenerId: string;

    enableBodyScroll: () => void;
    disableBodyScroll: () => void;

    constructor(
        isMobile: boolean,
        enableBodyScroll: () => void,
        disableBodyScroll: () => void,
        virtualKeyboardDetector: IVirtualKeyboardDetector
    ) {
        this.isMobile = isMobile;
        this.enableBodyScroll = enableBodyScroll;
        this.disableBodyScroll = disableBodyScroll;
        this.virtualKeyboardDetector = virtualKeyboardDetector;
    }

    createVirtualKeyboardListener() {
        this.virtualKeyboardListenerId = this.virtualKeyboardDetector.createListener(
            this.onVirtualKeyboardChange.bind(this),
            this.isMobile
        );
    }

    onVirtualKeyboardChange(event: VirtualKeyboardData) {
        const height = event.visibleHeight - this.getHeaderHeight();
        this.setElementHeight(height);

        if (this.jumpToBottom) {
            // We need to set the visibility of the jumpToBottom button after the animation is done
            setTimeout(() => this.jumpToBottom.setVisibility(), VKEYBOARD_ANIMATION_DURATION);
        }
    }

    handleScroll() {
        this.jumpToBottom.setVisibility();
    }

    open() {
        this.isOpen = true;
        this.jumpToBottom.setVisibility();

        if (this.isMobile) {
            this.scrollWebpageToTopWithTimeout();
            this.createVirtualKeyboardListener();
            this.disableBodyScroll();
        }
    }

    close() {
        this.isOpen = false;
        this.virtualKeyboardDetector.removeListener(this.virtualKeyboardListenerId);

        if (this.isMobile) {
            this.enableBodyScroll();
        }
    }

    scrollWebpageToTopWithTimeout() {
        // If we don't scroll to the top on Mobile it causes a glitch because of how the header is shown / hidden.
        // We give a timeout to allow the body scroll to be disabled before scrolling to the top,
        // so when we close the dropdown the actual scroll position of the body is restored.
        if (this.isMobile) {
            setTimeout(() => {
                window.scrollTo({ top: 0 });
            }, 300);
        }
    }

    setJumpToBottom(jumpToBottom: IJumpToBottom) {
        this.jumpToBottom = jumpToBottom;
    }

    getHeaderHeight() {
        const header = document.querySelector(`#${HEADER_ID}`) as HTMLElement;
        return header ? header.clientHeight : 0;
    }

    setElement(element: HTMLElement) {
        this.element = element;
    }

    setElementHeight(height: number) {
        if (!this.element) {
            return;
        }

        this.height = `${height}px`;
    }
}
